import React from 'react'
import StagesManager from '../../components/StagesManager';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Responsive from '../../components/Responsive';

import { nanoid } from 'nanoid';
import HttpServices from '../../utils/Http.services';
import { chooseFontColor, conditionalWidth, getAppletsAndhubsFromFramesList } from '../../utils/useful';
import Cookies from 'universal-cookie';
import { framesConfig } from '../../variables/framesStatics';
import Header from '../../components/header/Header';
import DriveSelectApplet from '../Drive/DriveSelectApplet';
import Drive from '../Drive';
import DashboardView from '../../components/views/DashboardView';
import HeaderDrivePortal from '../../components/header/HeaderDrivePortal';
import CustomLoader from '../../components/CustomLoader';

class DriveApplet extends React.Component {
    state = {
        stage: 1,
        modules: [],
        colors: {
            primaryColor: '#FFA01C',
            secondaryColor: '#F0C000',
            textColor: '#fff',
            iconInvert: true
        },
        headerConfig: {
            showToolbar: false, showSettings: false, showSettings: false, showFrames: false, isPortal: true, title: '{{lang}}Drive', type: 'drive',
        },
        showToolbar: false,
        page: {},
        applets: [],
        frames: [],

    }



    componentDidMount() {
        this.init(() => {

            const cookies = new Cookies();
            let token = cookies.get('token');
            if (token) {
                this.setState({ isLoading: true })
                this.waitForId(10)
            } else {
                this.setState({ pageStatus: 401 })
            }
            this.waitForId(10)
        })

    }

    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {

            this.checkDefaultTab()
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }


    componentDidUpdate(prevProps, prevState) {
        // if ((JSON.stringify(this.state.applet) != JSON.stringify(prevState.applet))) {
        //     console.log('applet change', this.state.applet)
        // }
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
                // console.log("DKLJDJKDLQK")
            })
        }
    }


    init = (cb) => {

        // console.log("INIT")
        let data = {}
        data.features = 'drive'
        this.setState({ isLoadingInit: true })
        data.frameType = 'drive'
        HttpServices.request('getMyFramesByType', data, (fetchResult, fetchError) => {

            // console.log(fetchResult)

            if (fetchError) {
                return
            }
            // fetchResult.info.map((element, index) => {
            //     if (element.applet.default) {
            //         element.applet.name = element.appletHub.fullname
            //     }
            // })
            // let applets = fetchResult.info
            let frames = fetchResult.frames ?? []
            // let hubs = []
            // let applets = []

            // if (Array.isArray(frames)) {
            //     // console.log('this.props.framessl',this.props.frames)
            //     frames.forEach(frame => {

            //         let frameInfo = framesConfig[frame.type]

            //         if (frameInfo) {
            //             Object.entries(frameInfo)?.map(([key, value]) => {
            //                 frame[key] = value
            //                 if (typeof value == 'string' && value.startsWith('{{')) {
            //                     let baseValue = value.replace(/{/g, '').replace(/}/g, '')
            //                     frame[key] = frame[baseValue]
            //                 }
            //             })
            //         }
            //         if (frame.type == 'collection' && Array.isArray(frame.fields)) {
            //             frame.fields.forEach(field => {
            //                 if (!field.key.includes("values.")) {
            //                     field.key = "values." + field.key
            //                 }
            //             })
            //         }

            //         let found = false
            //         hubs.forEach(hub => {
            //             if ((frame?.hub?._id ?? frame?.hub) == (hub._id ?? hub)) {
            //                 found = true
            //             }
            //         });
            //         if (!found && frame?.hub) {
            //             hubs.push(frame?.hub)
            //         }

            //         found = false
            //         applets.forEach(applet => {
            //             if (frame.applet?._id == applet._id) {
            //                 found = true
            //             }
            //         });
            //         if (!found) {
            //             applets.push(frame.applet)
            //         }
            //     })
            // }

            // applets.forEach(applet => {
            //     let found = false
            //     hubs.forEach(hub => {
            //         if (applet.appletHub?._id == hub._id) {
            //             found = true
            //         }
            //     });
            //     if (!found) {
            //         hubs.push(applet.appletHub)
            //     }

            // });

            // console.log("HUBS", hubs, applets, frames)
            getAppletsAndhubsFromFramesList(frames, (hubs, applets) => {

                this.setState({ hubs, applets, frames }, () => {
                    this.checkDefaultTab()

                    this.setState({ isLoadingInit: false })
                    if (cb) {
                        cb()
                    }
                })

            })


        })
    }



    checkDefaultTab() {
        let pathname = this.props.windowData.path//window.location.pathname.split('/')

        let type = pathname[this.props.baseUrl.length]
        let id = pathname[this.props.baseUrl.length + 1]


        // let hub = this.state.hubs.find(element => String(element?.username) == String(hubId))

        // let appletId = pathname[this.props.baseUrl.length + 1]
        // let applet = this.state.applets.find(element => String(element?.applet?._id) == String(appletId))?.applet
        // let frameId = pathname[this.props.baseUrl.length + 2]
        // let frame = this.state.frames.find(element => String(element?._id) == String(frameId))

        // console.log("checkDefaultTab", type, id)

        this.setState({ oldData: this.props.windowData }, () => {
            setTimeout(() => {
                this.setState({ pageStatus: 200 }, () => {
                    if (this.stageManager) {
                        if (id) {
                            let driveBaseURL = [...this.props.baseUrl]

                            // this.setState({ driveBaseURL }, () => {

                            switch (type) {

                                case 'file':

                                    this.setState({ driveBaseURL, page: null, }, () => {
                                        this.stageManager.changeStage('drive')
                                    })
                                    break;

                                case 'folder':
                                    // let frame = this.state.frames.find(element => String(element?._id) == String(id))
                                    // if (frame) {
                                    //     let hub = frame.appletHub
                                    //     let applet = frame.applet

                                    // driveBaseURL = [...driveBaseURL, type, frame?._id]
                                    // console.log(frame,hub,applet)

                                    this.setState({ driveBaseURL, page: null, }, () => {
                                        this.stageManager.changeStage('drive')
                                    })
                                    // }

                                    break;

                                case 'doc':

                                    // let hub = this.state.hubs.find(element => String(element?.username) == String(id))
                                    // if (hub) {
                                    this.setState({ driveBaseURL, currentHub: null, currentApplet: null, applet: null, currentFrame: null, page: null }, () => {
                                        this.stageManager.changeStage('drive')
                                    })
                                    // }

                                    break;


                                case 'hub':

                                    let hub = this.state.hubs.find(element => String(element?.username) == String(id))
                                    if (hub) {
                                        this.setState({ driveBaseURL, currentHub: hub, currentApplet: null, applet: null, currentFrame: null, page: null }, () => {
                                            this.stageManager.changeStage('home')
                                        })
                                    }

                                    break;


                                case 'applet':

                                    let applet = this.state.applets.find(element => (String(element?._id) == String(id) || String(element?.slug) == String(id)))
                                    // console.log("applet", id, applet,this.state.applets)
                                    if (applet) {
                                        let hub = applet.hub
                                        this.setState({ driveBaseURL, currentHub: hub, currentApplet: applet, applet: applet, currentFrame: null, page: null }, () => {
                                            this.stageManager.changeStage('home')
                                        })
                                    }

                                    break;


                                case 'frame':
                                    let frame = this.state.frames.find(element => String(element?._id) == String(id))
                                    if (frame) {
                                        let hub = frame.hub
                                        let applet = frame.applet

                                        driveBaseURL = [...driveBaseURL, type, frame?._id]
                                        // console.log(frame,hub,applet)

                                        this.setState({ driveBaseURL, currentHub: hub, currentApplet: applet, applet, currentFrame: frame, page: frame }, () => {
                                            this.stageManager.changeStage('drive')
                                        })
                                    }

                                    break;

                                default:
                                    this.stageManager.changeStage('home')
                                    break;

                            }

                            // })
                        } else {
                            this.setState({ currentHub: null, currentApplet: null, page: null, currentFrame: null }, () => {
                                this.stageManager.changeStage('home')
                            })

                        }


                        //     if (frameId) {
                        //         this.filterFrames(appletId, () => {
                        //             this.setState({ currentHub: hub, currentApplet: applet, applet, currentFrame: frame, page: frame }, () => {
                        //                 this.stageManager.changeStage('drive')
                        //             })
                        //         })
                        //     } else if (appletId) {
                        //         this.setState({ currentHub: hub, currentApplet: applet, applet, page: null, currentFrame: null }, () => {
                        //             // console.log('updateapplet', this.state.applet)
                        //             this.filterFrames(appletId, () => {
                        //                 this.stageManager.changeStage('home')
                        //             })
                        //         })
                        //     } else if (hubId) {
                        //         this.setState({ currentHub: hub, currentApplet: null, page: null, currentFrame: null }, () => {
                        //             this.filterFrames(appletId, () => {
                        //                 this.stageManager.changeStage('home')
                        //             })
                        //         })
                        //     } else {
                        //         this.setState({ currentHub: null, currentApplet: null, page: null, currentFrame: null }, () => {
                        //             this.stageManager.changeStage('home')
                        //         })
                        //     }
                        // } else {

                    }
                })
            }, 10);

        })


    }

    // checkDefaultTab() {
    //     let pathname = this.props.windowData.path//window.location.pathname.split('/')

    //     let hubId = pathname[this.props.baseUrl.length]
    //     let hub = this.state.hubs.find(element => String(element?.username) == String(hubId))

    //     let appletId = pathname[this.props.baseUrl.length + 1]
    //     let applet = this.state.applets.find(element => String(element?.applet?._id) == String(appletId))?.applet
    //     let frameId = pathname[this.props.baseUrl.length + 2]
    //     let frame = this.state.frames.find(element => String(element?._id) == String(frameId))

    //     // console.log("checkDefaultTab",hubId, appletId, frameId)

    //     this.setState({ oldData: this.props.windowData }, () => {
    //         setTimeout(() => {
    //             this.setState({ pageStatus: 200 }, () => {
    //                 if (this.stageManager) {
    //                     if (frameId) {
    //                         this.filterFrames(appletId, () => {
    //                             this.setState({ currentHub: hub, currentApplet: applet, applet, currentFrame: frame, page: frame }, () => {
    //                                 this.stageManager.changeStage('drive')
    //                             })
    //                         })
    //                     } else if (appletId) {
    //                         this.setState({ currentHub: hub, currentApplet: applet, applet, page: null, currentFrame: null }, () => {
    //                             // console.log('updateapplet', this.state.applet)
    //                             this.filterFrames(appletId, () => {
    //                                 this.stageManager.changeStage('home')
    //                             })
    //                         })
    //                     } else if (hubId) {
    //                         this.setState({ currentHub: hub, currentApplet: null, page: null, currentFrame: null }, () => {
    //                             this.filterFrames(appletId, () => {
    //                                 this.stageManager.changeStage('home')
    //                             })
    //                         })
    //                     } else {
    //                         this.setState({ currentHub: null, currentApplet: null, page: null, currentFrame: null }, () => {
    //                             this.stageManager.changeStage('home')
    //                         })
    //                     }
    //                 } else {

    //                 }
    //             })
    //         }, 10);

    //     })


    // }
    filterFrames = (id, cb) => {
        let frameList = JSON.parse(JSON.stringify(this.state.frames))
        // console.log('frameList', frameList)
        frameList = frameList.filter((frame) => String(frame.applet) == String(id))
        // console.log('framesList', frameList)
        this.setState({ modules: frameList }, () => {
            if (cb)
                cb()
        })
    }
    checkApplet = () => {
        this.setState({ currentApplet: this.props.applet._id })
    }

    selectApplet = (value) => {
        this.setState({ currentApplet: value }, () => {
            // console.log('currentapplet', this.state.currentApplet)
        })
    }

    setData = (key, value, reference, cb) => {
        if (key == 'applet') {
            console.warn('appletchangedddd')
        }
        if (reference == 'DrivePortal') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    setCurrentApplet = (key, value, cb) => {
        this.setState({ [key]: value }, () => {
            if (cb) {
                cb()
            }
        })
    }
    changePage = (page, info, back) => {
        if (page) {
            let extraPath = Array.isArray(page) ? page : [page]
            let fullPath = []
            fullPath = [...this.props.baseUrl]
            if (this.state.applet?._id && !extraPath.includes(this.state.applet?._id) && !back) {
                fullPath = [...fullPath, this.state.applet._id]
            }
            fullPath = [...fullPath, ...extraPath]
            this.changeWindow(fullPath, info)
        } else {
            let fullPath = [...this.props.baseUrl]
            this.changeWindow(fullPath, info)

        }
    }
    // changePage = (page, info) => {
    //     console.log('page, info', page, info)
    //     console.log('windowsdata', this.props.windowData.path)
    //     let extraPath = Array.isArray(page) ? page : [page]
    //     // console.log('changePage2', extraPath)
    //     let fullPath = []
    //     if (this.props.windowData.path[this.props.baseUrl.length] && !extraPath.includes(this.props.windowData.path[this.props.baseUrl.length])) {
    //         fullPath = [this.props.windowData.path[this.props.baseUrl.length]]
    //     }
    //     fullPath = [...this.props.baseUrl, ...extraPath]
    //     console.log('changePage3', fullPath)
    //     this.changeWindow(fullPath, info)
    // }
    changeWindow = (list, info) => {
        if (Array.isArray(list)) {
            let finalList = []
            list.forEach(value => {
                let one = value
                // console.log('valueeee', value)
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        one = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
                if (one) {
                    finalList.push(one)
                }
            });
            let data = { type: 'applet', path: finalList }
            if (info) {
                data.params = info
            }
            this.props.changeWindow('applet', data)
        }
    }
    setHeader = (key, value) => {
        // console.log("setHeader")
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                // console.log(object)
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                // console.log({ ...this.state.headerConfig, [key]: value })

                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }
    functionsHandler = (type, name, data, info) => {

        // console.log(type)
        // console.log(name)

        if (type) {
            if (type == 'admin') {
                this[name](data, info)
            } else {
                if (this[type] && this[type][name]) {
                    this[type][name](data)
                }
            }
        } else {
            if (this[name]) {
                this[name](data, info)
            }
        }
    }

  

    setCurrentFrame = (folder) => {

        this.setState({ currentHub: folder.appletHub, currentApplet: folder.applet, applet: folder.applet, currentFrame: folder.frame, page: folder.frame }, () => {

        })
    }


    changeNav = (type, id) => {


        let newLink = [type, id]
        // if (type == 'folder') {
        //     newLink = ['folder']
        //     newLink.push(item.link)
        // }

        this.props.changeWindowLink(newLink)


    }





    render() {
        // let variables = {
        //     applet: this.props.applet._id,
        //     appletHub: this.props.applet.hub
        // }
        let variables = {
            applet: this.state.currentApplet,
            appletId: this.state.currentApplet?._id,
            appletHub: this.state.currentHub?._id
        }

        let colors = this.state.colors ?? {}
        let applet = this.state.applet

        if (applet?.colorType == 'sameAsHub') {
            if (this.props.user.info?.colors) {
                colors = this.props.user.info.colors
            }
        }

        if (applet?.colorType == "custom" && applet?.colors) {
            colors = applet?.colors
        }

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false
        // console.log(chooseFontColor(colors.textColor),colors.textColor )
        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`

        // console.log('colors', colors)

        // let driveBaseURL = [...this.props.baseUrl]
        // if (this.state.currentHub) {
        //     driveBaseURL.push(this.state.currentHub.username)
        //     if (this.state.currentApplet) {
        //         // driveBaseURL.push(this.state.currentApplet.slug ?? this.state.currentApplet._id)
        //         driveBaseURL.push(this.state.currentApplet._id)

        //         if (this.state.currentFrame) {
        //             // driveBaseURL.push(this.state.currentFrame.slug ?? this.state.currentFrame._id)
        //             driveBaseURL.push(this.state.currentFrame._id)
        //         }
        //     }
        // }
        // console.log(driveBaseURL)
        return (
            <div className="bg-white w-100 d-flex flex-column window-content-radius h-100" style={{ backgroundColor: '#F5F5F5' }}  >
                <div style={{ position: 'relative', top: 0 }}>
                    {/* {console.log('this.state.modules', this.state.modules)} */}
                    <HeaderDrivePortal ref={el => this.header = el} config={this.state.headerConfig} currentHub={this.state.currentHub} currentApplet={this.state.currentApplet} currentFrame={this.state.currentFrame} isPortal={true} changeNav={this.changeNav} setCurrentApplet={this.setCurrentApplet} frames={this.state.modules} appletType={this.props.type} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} isDesktop={this.props.isDesktop} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.state.applet} width={this.props.width} colors={colors} features={this.props.applet?.features} setHeader={this.setHeader} backActionMobile={this.backActionMobile} />
                </div>

                {this.state.isLoadingInit && (
                    <div className="mt-2 d-flex justify-content-center pt-5">
                        <CustomLoader isLoading={true} />
                    </div>
                )}

                {!this.state.isLoadingInit && (

                    <StagesManager ref={el => this.stageManager = el} height={'0px'} className={'flex-1'} fast={true}>
                        <DriveSelectApplet stage={1} stageName="home" type='Drive' ref={el => this.selectApplet = el} applets={this.state.applets} currentHub={this.state.currentHub} currentApplet={this.state.currentApplet} currentFrame={this.state.currentFrame} frames={this.state.frames} hubs={this.state.hubs} setCurrentApplet={this.setCurrentApplet} setData={this.setData} changePage={this.changePage} functionsHandler={this.functionsHandler} openSelectAppletModal={this.openSelectAppletModal} setHeader={this.setHeader} isPortal={true} width={this.props.width} />
                        {/* <DashboardView stageName={''} permissionLevel={this.props.permissionLevel} permissions={this.props.permissions} stage={1} language={this.props.language} setData={this.setData} setHeader={this.setHeader} onClick={this.changePage} applet={this.state.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} user={this.props.user} modules={this.state.modules} changePage={this.changePage} title={"Manage"} description={"Manage things and applets"} baseUrl={this.props.baseUrl} variables={this.state.variables} isPortal={true} /> */}
                        <Drive
                            stage={1}
                            stageName={'drive'}
                            applet={this.state.applet}
                            windowData={this.props.windowData}
                            page={this.state.page}
                            applets={this.state.applets}
                            isApplet={this.props.isApplet}
                            isPortal={true}
                            // currentApplet={this.props.currentApplet}
                            variables={variables}
                            changePage={this.changePage}
                            selectApplet={this.props.selectApplet}
                            goToHub={this.props.goToHub}
                            currentHub={this.state.currentHub}
                            currentApplet={this.state.currentApplet}
                            currentFrame={this.state.currentFrame}
                            setCurrentFrame={this.setCurrentFrame}
                            initData={this.state.data}
                            setCurrentApplet={this.setCurrentApplet}
                            setData={this.setData}
                            width={this.props.width}
                            language={this.props.language}
                            setHeader={this.setHeader}
                            colors={this.props.colors}
                            changeWindow={this.changeWindow}
                            changeWindowLink={this.props.changeWindowLink}
                            isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} permissions={this.props.permissions}
                            baseUrl={this.state.driveBaseURL ?? [...this.props.baseUrl]} lastSelected={this.props.lastSelected}
                            height={this.props.height}
                            route={this.props.route}
                            setWindowInfo={this.props.setWindowInfo}
                            data={this.props.data}
                        />
                    </StagesManager>
                )}
            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DriveApplet);